/* Steel Imperial Coins — experience behavior.
   Scroll choreography, music controller, gallery lightbox,
   acquisition configurator, policy modals. */

(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- chrome visibility (V3: persistent navigation) ---------- */
  var chrome = document.getElementById("chrome");
  if (chrome) chrome.classList.add("on");

  /* ---------- reveal on scroll ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
  if ("IntersectionObserver" in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px 0px 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---------- Scroll choreography (homepage cinematic sections only) ---------- */
  var descent = document.getElementById("descent");
  var threshold = document.getElementById("threshold");
  var play = document.getElementById("play");
  var hasChoreography = !!(descent && threshold && play);
  var beat2 = hasChoreography ? descent.querySelector(".beat-2") : null;
  var line1 = hasChoreography ? descent.querySelector(".line-1") : null;
  var line2 = hasChoreography ? descent.querySelector(".line-2") : null;
  var hoardImg = hasChoreography ? document.getElementById("hoardImg") : null;
  var revealedWord = hasChoreography ? document.getElementById("revealedWord") : null;
  var pbeats = hasChoreography ? play.querySelectorAll(".pbeat") : [];

  function scrub() {
    if (!hasChoreography) return;
    var vh = window.innerHeight;

    /* descent: beat crossfade + line swap across ~120vh */
    var r = descent.getBoundingClientRect();
    var dProg = Math.min(1, Math.max(0, -r.top / (r.height - vh)));
    if (reduceMotion) {
      beat2.style.opacity = dProg > 0.5 ? 1 : 0;
      line1.style.opacity = dProg > 0.5 ? 0 : 1;
      line2.style.opacity = dProg > 0.5 ? 1 : 0;
    } else {
      var cross = Math.min(1, Math.max(0, (dProg - 0.3) / 0.4));
      beat2.style.opacity = cross;
      var swap = Math.min(1, Math.max(0, (dProg - 0.42) / 0.16));
      line1.style.opacity = 1 - swap;
      line2.style.opacity = swap;
    }

    /* threshold: lid lift = dezoom + grade shift to neutral, word at 70-82vh.
       The section is ~100vh, so progress runs over one viewport of scroll
       travel: 0 when the section top reaches the viewport top, 1 a viewport later. */
    var t = threshold.getBoundingClientRect();
    var tProg = Math.min(1, Math.max(0, -t.top / vh));
    if (!reduceMotion) {
      var scale = 1.1 - 0.1 * tProg;
      var sepia = 0.42 * (1 - tProg);
      var bright = 0.92 + 0.08 * tProg;
      hoardImg.style.transform = "scale(" + scale.toFixed(4) + ")";
      hoardImg.style.filter = "sepia(" + sepia.toFixed(3) + ") saturate(1.15) brightness(" + bright.toFixed(3) + ")";
    } else {
      hoardImg.style.transform = "scale(1)";
      hoardImg.style.filter = "sepia(0) saturate(1.15) brightness(1)";
    }
    var wIn = Math.min(1, Math.max(0, (tProg - 0.70) / 0.06));
    var wOut = Math.min(1, Math.max(0, (tProg - 0.82) / 0.10));
    revealedWord.style.opacity = (wIn * (1 - wOut)).toFixed(3);

    /* play: four-beat crossfade across ~160vh : Hand -> Tray -> Felt -> Motion */
    var pr = play.getBoundingClientRect();
    var pProg = Math.min(1, Math.max(0, -pr.top / Math.max(1, pr.height - vh)));
    if (!reduceMotion) {
      var fade = 0.125;
      for (var i = 0; i < pbeats.length; i++) {
        var fin = Math.min(1, Math.max(0, (pProg - (i / 4 - fade)) / fade));
        var fout = (i === pbeats.length - 1)
          ? 1
          : 1 - Math.min(1, Math.max(0, (pProg - ((i + 1) / 4)) / fade));
        pbeats[i].style.opacity = (fin * fout).toFixed(3);
      }
    } else {
      for (var j = 0; j < pbeats.length; j++) { pbeats[j].style.opacity = 1; }
    }
  }
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!hasChoreography) return;
    if (!ticking) {
      window.requestAnimationFrame(function () { scrub(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener("resize", scrub);
  scrub();

  /* ---------- music controller : ORIGINAL COMPOSITION ----------
     V3.2n behavior: attempt audible autoplay as early as the browser permits,
     at a low background volume (~22%), with a ~2 second gentle fade-in.
     If the browser blocks autoplay, begin on the visitor's FIRST qualifying
     interaction anywhere on the site. Plays once; never loops; never
     auto-restarts. Playback POSITION and play/pause state persist across
     internal page loads via sessionStorage: a track that is playing resumes
     from approximately the same timestamp on the next page; a manually
     paused track stays paused (the manualPause flag is set at click time,
     so even navigating mid-fade cannot restart it); a finished track stays
     finished. The flag lives in sessionStorage: it survives navigation but
     a new visit starts fresh. */
  var audio = document.getElementById("composition");
  var toggle = document.getElementById("soundToggle");
  var toggleGlyph = toggle ? toggle.querySelector(".toggle-glyph") : null;
  var toggleText = toggle ? toggle.querySelector(".toggle-text") : null;
  var nowPlaying = document.getElementById("nowPlaying");
  var fadeTimer = null;
  var MUSIC_TARGET = 0.22; /* low background volume, ~22% */
  var MUSIC_STATE_KEY = "sic-composition-state"; /* { t, playing, ended, started } */

  function setPlayingUI(playing) {
    if (!toggle) return;
    toggle.classList.toggle("playing", playing);
    toggle.setAttribute("aria-pressed", playing ? "true" : "false");
    toggle.setAttribute("aria-label", playing ? "Pause music" : "Play original composition");
    if (toggleGlyph) toggleGlyph.textContent = playing ? "❚❚" : "▶";
    if (toggleText) toggleText.textContent = playing ? "PAUSE MUSIC" : "PLAY ORIGINAL COMPOSITION";
    if (nowPlaying) {
      nowPlaying.classList.toggle("playing", playing);
      nowPlaying.setAttribute("aria-hidden", playing ? "false" : "true");
    }
  }

  /* gentle fade toward a target volume over ~2 seconds */
  function fadeTo(target, done) {
    if (fadeTimer) clearInterval(fadeTimer);
    var steps = 20, i = 0;
    var delta = (target - audio.volume) / steps;
    fadeTimer = setInterval(function () {
      i++;
      var v = audio.volume + delta;
      if (i >= steps) { v = target; clearInterval(fadeTimer); if (done) done(); }
      audio.volume = Math.max(0, Math.min(1, v));
    }, 100);
  }
  function readMusicState() {
    try {
      var raw = sessionStorage.getItem(MUSIC_STATE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function writeMusicState(s) {
    try { sessionStorage.setItem(MUSIC_STATE_KEY, JSON.stringify(s)); } catch (e) { /* private mode */ }
  }
  var musicState = readMusicState() || { t: 0, playing: false, ended: false, started: false, manualPause: false };
  function saveMusicState() {
    if (!audio) return;
    musicState.t = audio.currentTime || 0;
    musicState.playing = !audio.paused && !audio.ended;
    writeMusicState(musicState);
  }
  /* The fallback listeners are armed synchronously at init, so the very first
     interaction counts even if the initial autoplay attempt is still pending. */
  function onFirstInteraction() {
    document.removeEventListener("pointerdown", onFirstInteraction);
    document.removeEventListener("keydown", onFirstInteraction);
    document.removeEventListener("touchstart", onFirstInteraction);
    var stNow = readMusicState();
    if (stNow && stNow.manualPause) return; /* manual pause wins over first-interaction resume */
    resumePlayback();
  }
  function armFirstInteraction() {
    document.addEventListener("pointerdown", onFirstInteraction);
    document.addEventListener("keydown", onFirstInteraction);
    document.addEventListener("touchstart", onFirstInteraction);
  }
  function disarmFirstInteraction() {
    document.removeEventListener("pointerdown", onFirstInteraction);
    document.removeEventListener("keydown", onFirstInteraction);
    document.removeEventListener("touchstart", onFirstInteraction);
  }
  function seekAudio(to) {
    if (!audio || !(to > 0)) return;
    try {
      if (audio.readyState > 0) {
        var d = audio.duration;
        audio.currentTime = (d && isFinite(d)) ? Math.min(to, Math.max(0, d - 0.25)) : to;
      } else {
        audio.addEventListener("loadedmetadata", function onMeta() {
          audio.removeEventListener("loadedmetadata", onMeta);
          seekAudio(to);
        });
      }
    } catch (e) {}
  }
  function startPlayback(fromTime) {
    if (!audio) return;
    if (!musicState.started || musicState.ended) {
      musicState.started = true;
      musicState.ended = false;
    }
    if (musicState.ended) return;
    try { audio.muted = true; } catch (e) {} /* muted autoplay attempt: browsers permit muted play(); unmuted in .then() below */
    try { audio.volume = 0; } catch (e) {}
    seekAudio(fromTime || 0);
    var p = null;
    try { p = audio.play(); } catch (e) {}
    if (p && p.then) {
      p.then(function () {
        disarmFirstInteraction();
        try { audio.muted = false; } catch (e) {}
        fadeTo(MUSIC_TARGET);
        setPlayingUI(true);
        musicState.started = true;
        musicState.ended = false; /* deliberate (re)start: clear any stale finished flag */
        saveMusicState();
      }).catch(function () {
        try { audio.muted = false; } catch (e) {} /* so the armed first-interaction retry plays audibly */
        /* stays armed: the next interaction retries from the saved timestamp */
      });
    }
  }
  function resumePlayback() {
    var st = readMusicState();
    startPlayback(st && !st.ended ? st.t : 0);
  }
  /* Cross-page continuity: the visitor already started the track, so restore it
     at the saved timestamp. Browsers block AUDIBLE autoplay on a fresh page load
     (volume 0 does not satisfy autoplay policy — only the muted flag does), so
     begin muted, which is always permitted, and unmute once playback is underway. */
  function resumeFromSavedTime(fromTime) {
    if (!audio || !audio.paused) return;
    var t = Math.max(0, fromTime || 0);
    try { if (isFinite(audio.duration) && t >= audio.duration) t = 0; } catch (e) { /* metadata not ready */ }
    seekAudio(musicState.t || 0);
    audio.muted = true;
    audio.volume = 0;
    var p = audio.play();
    if (p && p.then) {
      p.then(function () {
        disarmFirstInteraction();
        audio.muted = false;
        fadeTo(MUSIC_TARGET);
        setPlayingUI(true);
        musicState.started = true;
        musicState.ended = false; /* deliberate (re)start: clear any stale finished flag */
        saveMusicState();
      }).catch(function () {
        audio.muted = false; /* so the armed first-interaction retry plays audibly */
        /* stays armed: the next interaction retries from the saved timestamp */
      });
    }
  }
  /* persist position while playing (throttled), on pause/play, and on unload */
  var saveTick = 0;
  if (audio) {
    audio.addEventListener("timeupdate", function () {
      var now = Date.now();
      if (now - saveTick > 1000) { saveTick = now; saveMusicState(); }
    });
    audio.addEventListener("pause", function () { setPlayingUI(false); saveMusicState(); });
    audio.addEventListener("play", function () { setPlayingUI(true); saveMusicState(); });
    audio.addEventListener("ended", function () {
      musicState.ended = true;
      musicState.playing = false;
      writeMusicState(musicState);
      setPlayingUI(false); /* finished: stays finished, no loop, no restart */
    });
  }
  window.addEventListener("beforeunload", saveMusicState);
  if (toggle) { toggle.addEventListener("click", function () {
    if (audio && audio.paused) {
      musicState.manualPause = false; writeMusicState(musicState); /* manual Play clears the session pause flag */
      resumePlayback();
    } else if (audio) {
      musicState.manualPause = true; writeMusicState(musicState); /* manual Pause: remembered for the session, effective immediately (even mid-fade) */
      setPlayingUI(false); /* wording/state updates immediately */
      fadeTo(0, function () { audio.pause(); }); /* the pause event persists the paused state */
    }
  }); }
  /* init: resume a playing track from its saved timestamp; a manually paused
     track stays paused (no first-interaction arming); a finished track stays
     finished; a fresh visit starts from the beginning. */
  if (musicState.manualPause && !musicState.ended) {
    /* Visitor manually paused: stays paused for the rest of the session.
       No auto-resume, no first-interaction arming — only a manual Play clears this. */
    setPlayingUI(false);
  } else if (musicState.ended) {
    setPlayingUI(false);
  } else if (musicState.started && musicState.playing) {
    /* The track was playing when the visitor navigated: restore it at the saved
       timestamp. The toggle reflects the playing state immediately; the paused
       branch below stays untouched, so a manual pause still persists. */
    setPlayingUI(true);
    resumeFromSavedTime(musicState.t);
    armFirstInteraction(); /* fallback: first tap/click retries if the muted attempt is blocked */
  } else if (musicState.started && !musicState.playing && musicState.t > 0) {
    setPlayingUI(false);
  } else {
    armFirstInteraction();
    startPlayback(0);
  }

  /* ---------- lightbox ---------- */
  var lightbox = document.getElementById("lightbox");
  var lightboxImg = document.getElementById("lightboxImg");
  var lightboxCap = document.getElementById("lightboxCap");
  document.querySelectorAll(".gallery button, .play-pair button").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var img = btn.querySelector("img");
      lightboxImg.src = img.src;
      lightboxImg.alt = img.alt;
      lightboxCap.textContent = btn.getAttribute("data-cap") || "";
      lightbox.classList.add("open");
      document.body.style.overflow = "hidden";
    });
  });
  function closeLightbox() {
    lightbox.classList.remove("open");
    document.body.style.overflow = "";
  }
  lightbox.querySelector(".close").addEventListener("click", closeLightbox);
  lightbox.addEventListener("click", function (e) { if (e.target === lightbox) closeLightbox(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeLightbox(); closeModals(); } });
  /* ---------- Imperial Collection photo: click to enlarge ---------- */
  /* Opens the existing lightbox without triggering the edition radio selection. */
  document.querySelectorAll("button.imperial-photo").forEach(function(btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      var img = btn.querySelector("img");
      if (!img || !lightbox || !lightboxImg) return;
      lightboxImg.src = img.src;
      lightboxImg.alt = img.alt;
      if (lightboxCap) lightboxCap.textContent = btn.getAttribute("data-cap") || "";
      lightbox.classList.add("open");
      document.body.style.overflow = "hidden";
    });
  });  

  /* ---------- policy + order modals ---------- */
  var openModalId = null;
  function openModal(id) {
    closeModals();
    document.getElementById(id).classList.add("open");
    document.body.style.overflow = "hidden";
    openModalId = id;
  }
  function closeModals() {
    document.querySelectorAll(".modal.open").forEach(function (m) { m.classList.remove("open"); });
    document.body.style.overflow = "";
    openModalId = null;
  }
  document.querySelectorAll("[data-modal]").forEach(function (el) {
    el.addEventListener("click", function () { openModal(el.getAttribute("data-modal")); });
  });
  var plateFull = document.getElementById("plateFull");
  if (plateFull) plateFull.addEventListener("click", function () { openModal("m-plate"); });
  document.querySelectorAll(".modal").forEach(function (m) {
    m.querySelector(".close").addEventListener("click", closeModals);
    m.addEventListener("click", function (e) { if (e.target === m) closeModals(); });
  });

  /* ---------- acquisition configurator (acquire page only) ---------- */
  /* ---------- acquisition configurator (acquire page only) ---------- */
  var BASE = 6495, IMPERIAL = 13189, COMPANION = 199, PLATE = 49, GIFT = 9.99;
  var optCompanion = document.getElementById("optCompanion");
  var optPlate = document.getElementById("optPlate");
  var optGift = document.getElementById("optGift");
  var plateFields = document.getElementById("plateFields");
  var giftFields = document.getElementById("giftFields");
  var giftMessage = document.getElementById("giftMessage");
  var giftCount = document.getElementById("giftCount");
  var totalAmount = document.getElementById("totalAmount");
  var acquireSection = document.getElementById("acquire");
  var singlePlateWrap = document.getElementById("singlePlateWrap");
  var dualPlateWrap = document.getElementById("dualPlateWrap");
  var optPlateRoyal = document.getElementById("optPlateRoyal");
  var optPlateLegend = document.getElementById("optPlateLegend");
  var plateRoyalFields = document.getElementById("plateRoyalFields");
  var plateLegendFields = document.getElementById("plateLegendFields");
  var companionName = document.getElementById("companionName");
  var companionDesc = document.getElementById("companionDesc");
  var acquireHeadline = document.getElementById("acquireHeadline");
  var headPrice = document.getElementById("headPrice");

  function isImperial() {
    var sel = document.querySelector('input[name="edition"]:checked');
    return sel && sel.value === "The Imperial Collection";
  }

  if (optCompanion && optPlate && optGift && plateFields && giftFields && totalAmount && acquireSection) {
  function fmt(n) { return "$" + n.toLocaleString("en-US"); }
  function escHtml(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function currentTotal() {
    var t = isImperial() ? IMPERIAL : BASE;
    if (optCompanion.checked) t += COMPANION;
    if (!isImperial() && optPlate.checked) t += PLATE;
    if (isImperial() && optPlateRoyal && optPlateRoyal.checked) t += PLATE;
    if (isImperial() && optPlateLegend && optPlateLegend.checked) t += PLATE;
    if (optGift.checked) t += GIFT;
    return t;
  }
  function renderTotal() { totalAmount.textContent = fmt(currentTotal()); }

  function onEditionChange() {
    var imp = isImperial();
    if (singlePlateWrap) singlePlateWrap.hidden = imp;
    if (dualPlateWrap) dualPlateWrap.hidden = !imp;
    if (companionName) companionName.textContent = imp ? "Add an additional Companion" : "The Companion";
    if (companionDesc) companionDesc.textContent = imp
      ? "One Companion is already included with The Imperial Collection. Add a second cigar and bourbon box."
      : "Cigar and bourbon box. Sold empty except for the fitted components and the humidifier.";
    if (acquireHeadline) acquireHeadline.textContent = imp
      ? "Both complete First Edition collections, with the Imperial cigar box."
      : "One complete First Edition collection.";
    if (headPrice) headPrice.textContent = imp ? fmt(IMPERIAL) : fmt(BASE);
    if (imp && optPlate) { optPlate.checked = false; if (plateFields) plateFields.classList.remove("open"); }
    if (!imp) {
      if (optPlateRoyal) { optPlateRoyal.checked = false; if (plateRoyalFields) plateRoyalFields.classList.remove("open"); }
      if (optPlateLegend) { optPlateLegend.checked = false; if (plateLegendFields) plateLegendFields.classList.remove("open"); }
    }
    renderTotal();
  }
  document.querySelectorAll('input[name="edition"]').forEach(function(radio) {
    radio.addEventListener("change", onEditionChange);
  });

  optCompanion.addEventListener("change", renderTotal);
  optPlate.addEventListener("change", function() {
    plateFields.classList.toggle("open", optPlate.checked);
    if (!optPlate.checked) clearPlateError();
    renderTotal();
  });
  if (optPlateRoyal) optPlateRoyal.addEventListener("change", function() {
    plateRoyalFields.classList.toggle("open", optPlateRoyal.checked);
    if (!optPlateRoyal.checked) clearPlateRoyalError();
    renderTotal();
  });
  if (optPlateLegend) optPlateLegend.addEventListener("change", function() {
    plateLegendFields.classList.toggle("open", optPlateLegend.checked);
    if (!optPlateLegend.checked) clearPlateLegendError();
    renderTotal();
  });
  optGift.addEventListener("change", function() {
    giftFields.classList.toggle("open", optGift.checked);
    renderTotal();
  });

  var plate1Input = document.getElementById("plate1");
  var plateError = document.getElementById("plateError");
  function showPlateError() {
    if (!plateError || !plate1Input) return;
    plateError.hidden = false;
    plate1Input.classList.add("plate-invalid");
    plate1Input.setAttribute("aria-invalid", "true");
  }
  function clearPlateError() {
    if (!plateError || !plate1Input) return;
    plateError.hidden = true;
    plate1Input.classList.remove("plate-invalid");
    plate1Input.removeAttribute("aria-invalid");
  }
  var plateR1Input = document.getElementById("plateR1");
  var plateRoyalError = document.getElementById("plateRoyalError");
  function showPlateRoyalError() {
    if (!plateRoyalError || !plateR1Input) return;
    plateRoyalError.hidden = false;
    plateR1Input.classList.add("plate-invalid");
    plateR1Input.setAttribute("aria-invalid", "true");
  }
  function clearPlateRoyalError() {
    if (!plateRoyalError || !plateR1Input) return;
    plateRoyalError.hidden = true;
    plateR1Input.classList.remove("plate-invalid");
    plateR1Input.removeAttribute("aria-invalid");
  }
  var plateL1Input = document.getElementById("plateL1");
  var plateLegendError = document.getElementById("plateLegendError");
  function showPlateLegendError() {
    if (!plateLegendError || !plateL1Input) return;
    plateLegendError.hidden = false;
    plateL1Input.classList.add("plate-invalid");
    plateL1Input.setAttribute("aria-invalid", "true");
  }
  function clearPlateLegendError() {
    if (!plateLegendError || !plateL1Input) return;
    plateLegendError.hidden = true;
    plateL1Input.classList.remove("plate-invalid");
    plateL1Input.removeAttribute("aria-invalid");
  }

  [["plate1", "c1", 17], ["plate2", "c2", 24], ["plate3", "c3", 24]].forEach(function(pair) {
    var field = document.getElementById(pair[0]);
    var count = document.getElementById(pair[1]);
    if (!field || !count) return;
    field.addEventListener("input", function() {
      if (field.value.length > pair[2]) field.value = field.value.slice(0, pair[2]);
      count.textContent = field.value.length;
      if (pair[0] === "plate1" && field.value.trim() !== "") clearPlateError();
    });
  });
  [["plateR1", "cR1", 17], ["plateR2", "cR2", 24], ["plateR3", "cR3", 24]].forEach(function(pair) {
    var field = document.getElementById(pair[0]);
    var count = document.getElementById(pair[1]);
    if (!field || !count) return;
    field.addEventListener("input", function() {
      if (field.value.length > pair[2]) field.value = field.value.slice(0, pair[2]);
      count.textContent = field.value.length;
      if (pair[0] === "plateR1" && field.value.trim() !== "") clearPlateRoyalError();
    });
  });
  [["plateL1", "cL1", 17], ["plateL2", "cL2", 24], ["plateL3", "cL3", 24]].forEach(function(pair) {
    var field = document.getElementById(pair[0]);
    var count = document.getElementById(pair[1]);
    if (!field || !count) return;
    field.addEventListener("input", function() {
      if (field.value.length > pair[2]) field.value = field.value.slice(0, pair[2]);
      count.textContent = field.value.length;
      if (pair[0] === "plateL1" && field.value.trim() !== "") clearPlateLegendError();
    });
  });

  giftMessage.addEventListener("input", function() {
    if (giftMessage.value.length > 250) giftMessage.value = giftMessage.value.slice(0, 250);
    giftCount.textContent = 250 - giftMessage.value.length;
  });

  function validatePlateInstance(prefix) {
    var line1Id = prefix === "royal" ? "plateR1" : prefix === "legend" ? "plateL1" : "plate1";
    var line1 = document.getElementById(line1Id);
    var engSel = prefix
      ? '[data-sic-engraving-' + prefix + '] input[type="radio"]:checked'
      : '[data-sic-engraving] input[type="radio"]:checked';
    var locSel = prefix
      ? '[data-sic-location-' + prefix + '] input[type=radio]:checked'
      : '[data-sic-location] input[type=radio]:checked';
    var engErrSel = prefix ? '[data-sic-engraving-error-' + prefix + ']' : '[data-sic-engraving-error]';
    var locErrSel = prefix ? '[data-sic-location-error-' + prefix + ']' : '[data-sic-location-error]';
    if (line1 && line1.value.trim() === "") {
      if (prefix === "royal") showPlateRoyalError();
      else if (prefix === "legend") showPlateLegendError();
      else showPlateError();
      line1.scrollIntoView({ block: "center", behavior: "smooth" });
      line1.focus({ preventScroll: true });
      return false;
    }
    var loc = document.querySelector(locSel);
    if (!loc) {
      var locErr = document.querySelector(locErrSel);
      if (locErr) locErr.hidden = false;
      var locFs = document.querySelector(prefix ? '[data-sic-location-' + prefix + ']' : '[data-sic-location]');
      if (locFs) locFs.scrollIntoView({ block: "center", behavior: "smooth" });
      return false;
    }
    var sty = document.querySelector(engSel);
    if (!sty) {
      var engErr = document.querySelector(engErrSel);
      if (engErr) engErr.hidden = false;
      var engFs = document.querySelector(prefix ? '[data-sic-engraving-' + prefix + ']' : '[data-sic-engraving]');
      if (engFs) engFs.scrollIntoView({ block: "center", behavior: "smooth" });
      return false;
    }
    return true;
  }

  document.getElementById("acquireBtn").addEventListener("click", function() {
    var edition = document.querySelector('input[name="edition"]:checked').value;
    var imp = isImperial();
    if (!imp && optPlate.checked) {
      if (!validatePlateInstance("")) return;
    }
    if (imp && optPlateRoyal && optPlateRoyal.checked) {
      if (!validatePlateInstance("royal")) return;
    }
    if (imp && optPlateLegend && optPlateLegend.checked) {
      if (!validatePlateInstance("legend")) return;
    }
    clearPlateError(); clearPlateRoyalError(); clearPlateLegendError();
    var rows = [];
    if (imp) {
      rows.push(["The Imperial Collection", "Royal + Legend + Companion", fmt(IMPERIAL)]);
    } else {
      rows.push(["One complete First Edition collection", edition, fmt(BASE)]);
    }
    if (optCompanion.checked) {
      rows.push(imp
        ? ["Additional Companion", "Second cigar and bourbon box", fmt(COMPANION)]
        : ["The Companion", "Cigar and bourbon box", fmt(COMPANION)]);
    }
    if (!imp && optPlate.checked) {
      var lines = [1, 2, 3].map(function(i) { return document.getElementById("plate" + i).value.trim(); })
        .filter(function(s) { return s.length > 0; });
      rows.push(["Personalized nameplate", lines.join(" / "), fmt(PLATE)]);
    }
    if (imp && optPlateRoyal && optPlateRoyal.checked) {
      var rlines = ["plateR1", "plateR2", "plateR3"].map(function(id) { return document.getElementById(id).value.trim(); })
        .filter(function(s) { return s.length > 0; });
      rows.push(["Personalized nameplate — Royal", rlines.join(" / "), fmt(PLATE)]);
    }
    if (imp && optPlateLegend && optPlateLegend.checked) {
      var llines = ["plateL1", "plateL2", "plateL3"].map(function(id) { return document.getElementById(id).value.trim(); })
        .filter(function(s) { return s.length > 0; });
      rows.push(["Personalized nameplate — Legend", llines.join(" / "), fmt(PLATE)]);
    }
    if (optGift.checked) {
      var graw = giftMessage.value;
      rows.push(["Gift presentation",
        graw.trim() !== "" ? escHtml(graw).replace(/\n/g, "<br>") : "Presentation card included",
        fmt(GIFT)]);
    }
    var html = rows.map(function(r) {
      return '<div class="spec-row"><dt>' + r[0] + '<br><span style="font-size:12px">' + r[1] + "</span></dt>" +
        '<dd style="text-align:right">' + r[2] + "</dd></div>";
    }).join("");
    html += '<div class="total-row" style="margin-top:18px"><span class="label">Total</span>' +
      '<span class="amount">' + fmt(currentTotal()) + "</span></div>" +
      '<p class="ship-line">Insured U.S. shipping included. Signature required for the coin shipment.</p>';
    document.getElementById("orderSummary").innerHTML = html;
    openModal("m-order");
  });

  renderTotal();
  onEditionChange();

  var checkoutBtn = document.getElementById("checkoutBtn");
  var cartNote = document.getElementById("cartNote");
  function variantIdFor(handle, done) {
    fetch("/products/" + handle + ".js")
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) { done(p && p.variants && p.variants.length ? p.variants[0].id : null); })
      .catch(function() { done(null); });
  }
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function() {
      var acquire = document.getElementById("acquire");
      var edition = document.querySelector('input[name="edition"]:checked').value;
      var imp = isImperial();
      var handles;
      if (imp) {
        handles = [
          { handle: acquire.dataset.royal, qty: 1, props: { Edition: "The Royal Edition (Imperial Collection)" } },
          { handle: acquire.dataset.legend, qty: 1, props: { Edition: "The Legend Edition (Imperial Collection)" } },
          { handle: acquire.dataset.companion, qty: 1, props: { Edition: "Companion (included with Imperial Collection)" } },
          optCompanion.checked ? { handle: acquire.dataset.companion, qty: 1, props: { Edition: "Additional Companion" } } : null,
          (optPlateRoyal && optPlateRoyal.checked) ? { handle: acquire.dataset.plate, qty: 1, props: plateRoyalProps() } : null,
          (optPlateLegend && optPlateLegend.checked) ? { handle: acquire.dataset.plate, qty: 1, props: plateLegendProps() } : null,
          optGift.checked ? { handle: acquire.dataset.gift, qty: 1, props: giftProps() } : null
        ].filter(Boolean);
      } else {
        handles = [
          { handle: edition === "The Royal Edition" ? acquire.dataset.royal : acquire.dataset.legend, qty: 1, props: { Edition: edition } },
          optCompanion.checked ? { handle: acquire.dataset.companion, qty: 1, props: null } : null,
          optPlate.checked ? { handle: acquire.dataset.plate, qty: 1, props: plateProps() } : null,
          optGift.checked ? { handle: acquire.dataset.gift, qty: 1, props: giftProps() } : null
        ].filter(Boolean);
      }
      cartNote.hidden = true;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = "Preparing your collection...";
      var resolved = [];
      (function next(i) {
        if (i >= handles.length) return sendToCart(resolved);
        variantIdFor(handles[i].handle, function(vid) {
          if (!vid) return cartFail();
          var item = { id: vid, quantity: handles[i].qty };
          if (handles[i].props) item.properties = handles[i].props;
          resolved.push(item);
          next(i + 1);
        });
      })(0);
      function plateProps() {
        var p = {}; var plate1 = document.getElementById("plate1"); if (plate1) p["Line 1"] = plate1.value; var sicStyleEl = document.querySelector('[data-sic-engraving] input[type="radio"]:checked'); if (sicStyleEl) p["Engraving Style"] = sicStyleEl.value;
        var l2 = (document.getElementById("plate2") || { value: "" }).value.trim();
        var l3 = (document.getElementById("plate3") || { value: "" }).value.trim();
        if (l2) p["Line 2"] = l2;
        if (l3) p["Line 3"] = l3; var sicLocEl = document.querySelector('[data-sic-location] input[type=radio]:checked'); if (sicLocEl) p["Nameplate Location"] = sicLocEl.value;
        return p;
      }
      function plateRoyalProps() {
        var p = { "Nameplate For": "Royal display box" };
        var r1 = document.getElementById("plateR1"); if (r1) p["Line 1"] = r1.value;
        var sty = document.querySelector('[data-sic-engraving-royal] input[type="radio"]:checked');
        if (sty) p["Engraving Style"] = sty.value;
        var l2 = (document.getElementById("plateR2") || { value: "" }).value.trim();
        var l3 = (document.getElementById("plateR3") || { value: "" }).value.trim();
        if (l2) p["Line 2"] = l2;
        if (l3) p["Line 3"] = l3;
        var loc = document.querySelector('[data-sic-location-royal] input[type=radio]:checked');
        if (loc) p["Nameplate Location"] = loc.value;
        return p;
      }
      function plateLegendProps() {
        var p = { "Nameplate For": "Legend display box" };
        var l1 = document.getElementById("plateL1"); if (l1) p["Line 1"] = l1.value;
        var sty = document.querySelector('[data-sic-engraving-legend] input[type="radio"]:checked');
        if (sty) p["Engraving Style"] = sty.value;
        var l2 = (document.getElementById("plateL2") || { value: "" }).value.trim();
        var l3 = (document.getElementById("plateL3") || { value: "" }).value.trim();
        if (l2) p["Line 2"] = l2;
        if (l3) p["Line 3"] = l3;
        var loc = document.querySelector('[data-sic-location-legend] input[type=radio]:checked');
        if (loc) p["Nameplate Location"] = loc.value;
        return p;
      }
      function giftProps() {
        var p = { "Gift Presentation": "Yes" };
        var raw = giftMessage.value;
        if (raw.trim() !== "") p["Gift Message"] = raw;
        return p;
      }
      function cartFail() {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = "Proceed to secure checkout";
        cartNote.hidden = false;
        cartNote.textContent = "This configuration is not connected to the store catalog yet. Please contact us to complete your order.";
      }
      /* SIC: one set per edition per order - remove any existing edition lines before an Acquire build is added. */ var SIC_EDITION_HANDLES = ["steel-imperial-coins-royal-edition", "steel-imperial-coins-legend-edition"]; function sicRemoveExistingEditionLines() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function(r) { return r.json(); }).then(function(cart) { var items = cart.items || []; var lines = []; items.forEach(function(item, index) { if (SIC_EDITION_HANDLES.indexOf(item.handle) !== -1) { lines.push(index + 1); } }); lines.sort(function(a, b) { return b - a; }); var chain = Promise.resolve(); lines.forEach(function(line) { chain = chain.then(function() { return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: "line=" + encodeURIComponent(line) + "&quantity=0" }); }); }); return chain; }).catch(function() {}); } function sendToCart(items) { sicRemoveExistingEditionLines().then(function() {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        }).then(function(r) {
          if (!r.ok) throw new Error("cart");
          window.location = "/cart";
        }).catch(cartFail);      });
      }
    });
  }
  } /* end acquire-page-only configurator + checkout */

  /* ---------- V3: keep theme preview across internal navigation ---------- */
  (function keepPreview() {
    var m = /[?&]preview_theme_id=(\d+)/.exec(window.location.search);
    if (!m) return;
    var pid = m[1];
    function stamp(root) {
      root.querySelectorAll('a[href^="/"], a[href^="./"], a[href^="../"]').forEach(function (a) {
        var href = a.getAttribute("href");
        if (!href || href.indexOf("preview_theme_id=") !== -1) return;
        a.setAttribute("href", href + (href.indexOf("?") !== -1 ? "&" : "?") + "preview_theme_id=" + pid);
      });
    }
    stamp(document);
  })();

  /* ---------- V3: mobile menu ---------- */
  var menuToggle = document.getElementById("menuToggle");
  var mobileMenu = document.getElementById("mobileMenu");
  var menuClose = document.getElementById("menuClose");
  function setMenu(open) {
    if (!mobileMenu || !menuToggle) return;
    mobileMenu.classList.toggle("open", open);
    mobileMenu.setAttribute("aria-hidden", open ? "false" : "true");
    menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    menuToggle.classList.toggle("active", open);
    document.body.style.overflow = open ? "hidden" : "";
  }
  if (menuToggle) menuToggle.addEventListener("click", function () { setMenu(true); });
  if (menuClose) menuClose.addEventListener("click", function () { setMenu(false); });
  if (mobileMenu) mobileMenu.querySelectorAll("a").forEach(function (a) {
    a.addEventListener("click", function () { setMenu(false); });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && mobileMenu && mobileMenu.classList.contains("open")) setMenu(false);
  });
})();

// SIC: preselect edition on Acquire from ?edition=royal|legend (product page funnel).
// Append to the END of assets/sic.js. Pure addition — no existing logic is modified.
// If the radio is not found or the param is absent/invalid, this silently does nothing
// and the page keeps its default (Royal) selection.
(function () {
  try {
    var q = new URLSearchParams(window.location.search).get('edition');
    if (!q) return;
    var v = q.toLowerCase();
    var want = v === 'legend' ? 'The Legend Edition' : v === 'royal' ? 'The Royal Edition' : null;
    if (!want) return;
    var apply = function () {
      var r = document.querySelector('input[name="edition"][value="' + want + '"]');
      if (r && !r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
  } catch (e) { /* no-op */ }
})();
